import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const PayoutTable = ({ title, payouts, type }) => {
  const { t } = useLanguage();

  // Translate payout hands
  const translateHand = (hand) => {
    const handMap = {
      'ROYAL FLUSH': t('royalFlush'),
      'STRAIGHT FLUSH': t('straightFlush'),
      'QUADS': t('fourOfAKind'),
      'FOUR OF A KIND': t('fourOfAKind'),
      'FULL HOUSE': t('fullHouse'),
      'FLUSH': t('flush'),
      'STRAIGHT': t('straight'),
      'TRIPS': t('threeOfAKind'),
      'THREE OF A KIND': t('threeOfAKind'),
      'OTHER HANDS': t('otherHands'),
    };
    return handMap[hand] || hand;
  };

  return (
    <div 
      className="rounded-xl p-3 mb-3 backdrop-blur-sm"
      style={{ 
        background: 'linear-gradient(145deg, rgba(26,26,46,0.95), rgba(22,33,62,0.95))',
        border: '1px solid rgba(255,215,0,0.3)',
        boxShadow: '0 4px 15px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,215,0,0.1)'
      }}
    >
      <h3 
        className="font-bold text-sm mb-3 tracking-wider text-center pb-2"
        style={{ 
          color: '#ffd700',
          borderBottom: '1px solid rgba(255,215,0,0.2)'
        }}
      >
        {title}
      </h3>
      <div className="space-y-1.5">
        {payouts.map((item, index) => (
          <div key={index} className="flex justify-between text-xs items-center">
            <span className="font-medium" style={{ color: '#e0e0e0' }}>{translateHand(item.hand)}</span>
            <span 
              className="font-bold px-2 py-0.5 rounded"
              style={{ 
                color: '#ffd700',
                background: 'rgba(255,215,0,0.1)'
              }}
            >
              {item.payout}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PayoutTable;
